import dayjs from '../../config/dayjs';

export const normalize = (status) => (status || '').toUpperCase();

const formatDate = (value) => (value ? dayjs(value).format('DD/MM/YY') : '');

export const historyDate = (invoice, ...statusCodes) => {
  const wanted = statusCodes.map(normalize);
  const entry = (invoice.historystatusSet || []).find((h) => wanted.includes(normalize(h.status)));
  return formatDate(entry?.createdAt);
};

export const historyDateAfter = (invoice, status, refDate) => {
  const matches = (invoice.historystatusSet || [])
    .filter((h) => normalize(h.status) === normalize(status))
    .sort((a, b) => dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf());
  const ref = refDate ? dayjs(refDate) : null;
  const entry = ref ? matches.find((h) => dayjs(h.createdAt).isAfter(ref)) : matches[0];
  return formatDate(entry?.createdAt);
};

// Position of each status in the linear factoring flow.
export const BASE_STATUS_RANK = {
  CREATED: 1,
  REJECTED: 1,
  REJECTEDPREOFFEREVALUATION: 1,
  PENDINGDOCUMENTSEXPIRED: 1,
  OFFERED: 2,
  PROCESSING: 3,
  PENDINGDOCUMENTSREVIEW: 3,
  PENDINGRATIFICATION: 3,
  REJECTEDDOCUMENTS: 3,
  REJECTEDRATIFICATION: 3,
  PENDINGTRANSFER: 4,
  REJECTEDTRANSFER: 4,
  TRANSFERED: 5,
  DEBT: 5,
  PARTIALCOLLECTION: 5,
  BADDEBT: 5,
  PROROGUED: 5,
  FINISHED: 6,
  SURPLUSWITHDRAWN: 6,
};

export const isStatusReached = (invoice, status, statusRank = BASE_STATUS_RANK) => (
  (statusRank[normalize(invoice?.status)] || 0) >= (statusRank[normalize(status)] || 0)
);

export const hasEvaluationRequest = (invoice) => (
  Boolean(invoice?.preoffer?.preofferevaluationrequest)
);

export const hasEvaluationDocumentReview = (invoice) => (
  (invoice?.preoffer?.preofferevaluationrequest?.pendingdocumentsreviewSet || []).length > 0
);

export const hasDocumentReview = (invoice) => Boolean(invoice?.reviewDocumentsManager);

export const hasRatification = (invoice) => {
  const assignedPriorityDatetime = invoice?.ratificationmanager?.assignedPriorityDatetime;
  return assignedPriorityDatetime != null && dayjs(assignedPriorityDatetime).isValid();
};

export const offeredDate = (invoice) => (
  historyDateAfter(invoice, 'OFFERED', invoice?.offer?.createdAt)
);

export const operationDate = (invoice) => formatDate(invoice?.dateOperation);

export const customerCessionDate = (invoice) => (
  formatDate(invoice?.customerToPlatformCessionDate)
);

export const paymentDate = (invoice) => formatDate(invoice?.paymentDate);

const debtDays = (invoice) => {
  if (!invoice.dateToPay) return 0;
  const reference = invoice.paymentDate ? dayjs(invoice.paymentDate) : dayjs();
  return Math.max(0, reference.diff(dayjs(invoice.dateToPay), 'day'));
};

export const debtDaysText = (invoice) => {
  const days = debtDays(invoice);
  if (!days) return '';
  return `${days} ${days === 1 ? 'día' : 'días'} de mora`;
};
